/**
 * Formats JSON data for display, handling string, object, and undefined inputs.
 * If the input is a JSON string, it will be parsed and re-stringified with indentation.
 * @param data - The data to format (can be a JSON string, object, or undefined)
 * @returns A formatted JSON string or fallback message
 */
const formatJson = (data: Record<string, unknown> | string | undefined): string => {
  if (!data) return 'No data';
  if (typeof data === 'string') {
    try {
      return JSON.stringify(JSON.parse(data), null, 2);
    } catch {
      return data;
    }
  }
  return JSON.stringify(data, null, 2);
};

export { formatJson };
